import styled from 'styled-components';

export const Wrapper = styled.div`
    .markets-container {
        padding: 3rem 2rem 2rem 2rem;
        position: relative;
    }
    .ant-table-column-title,.ant-table-thead > tr > th .ant-table-header-column {
        width: 100%;
    }
    .t-head-1{
        opacity:0
    }
    .t-head {
        margin-left:25.3%
    }
    .filter-header {
        display: flex;
        justify-content: space-between;
        padding: 0rem 1rem;
        margin-bottom: 1rem;
    }
    .coin-symbol-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        .coin-title {
            width: 25%;
            text-align: end;
        }
        .coin-wrap {
            margin-right: 0px;
        }
        .icon-wrapper {
            position: absolute;
        }
        .settings-icon {
            position: relative;
            left: 16px;
            bottom: 14px;
        }
        .config-content {
            display: flex;
        }
        .content-space1 {
            margin-left: 1rem;
        }
        .content-space2 {
            margin-left: 5px;
        }
        .coin-config-align {
            z-index: 2;
        }
    }
    .coin-symbol-wrapper:hover {
        .pairs {
            text-decoration: underline;
        }
    }
    a {
        text-decoration: none;
        color: black;
    }
    .volume-column {
        width: 18rem;
    }
    @media (max-width: 960px) {
        .filter-header {
            flex-direction: column;
            .create-pairs-btn {
                margin-top: 1rem;
                width: 265px;
            }
        }
        .table-wrapper {
            overflow-x: scroll;
        }
        .markets-container {
            padding: 0.5rem;
        }
    }
    @media (max-width:425px) {
        .markets-container {
            .filter-header {
                Button {
                    width: 100%;
                }
            }
            .right-content {
                .flex-container {
                    .btn-wrapper {
                        flex-direction:column;
                        .remove {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
`;

export const VolumeWrapper = styled.div`
    padding-left : 0.5rem;
    .ant-input-affix-wrapper {
        width: 200px;
    }
    .ant-select {
        width: 150px;
    }
    .ant-input {
        border-radius: 0px;
    }
    .ant-select-selection {
        border-radius: 0px;
    }
    .filter-container {
        margin-top: 1rem;
    }
    .full-width {
        flex: 1;
    }
    .custom {
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
        .eOznA {
            padding: 0px;
        }
        .quick-fees {
            color: #000;
            margin-left: 8rem;
        }
        .all-fees {
            color: #000;
        }
        .ant-tabs-bar {
            border-bottom: 1px solid #6C6C6C;
        }
        .ant-tabs-nav .ant-tabs-tab {
            margin: 0px;
        }
        .ant-tabs-ink-bar {
            top: 39px;
        }
        .fees-btn {
            .ant-btn {
                width: 120px;
                height: 30px;
            }
        }
        .exchange-btn {
            margin-left: 1rem;
            .ant-btn {
                width: 180px;
                height: 30px;
            }
        }
   }
   .coming-soon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 3rem;
        .soon-img {
            width: 100px;
        }
        span {
            font-weight: bold; 
            color: #000000;
        }
   }
`
export const OrdersWrapper = styled.div`
    .custom {
        .eOznA {
            padding: 0px;
        }
        .quick-fees {
            color: #000;
            margin-left: 8rem;
        }
        .all-fees {
            color: #000;
        }
        .ant-tabs-bar {
            border-bottom: 1px solid #6C6C6C;
        }
        .ant-tabs-ink-bar {
            top: 39px;
        }
        a {
            color: #0000FF;
        }
    }
    .table-container {
        margin-top: 2rem;
        .table-content {
            color: #000;
        }
        .ant-btn {
            width: 130px;
            height: 30px;
        }
        .ant-table-thead > tr > th {
            padding: 0rem 1rem;
            background: #F2F2F2;
            border-top: 1px solid #9B9B9B;
        }
        .ant-table-tbody > tr > td {
            color: #000;
        }
        .btn-wrapper {
            text-align: end;
            margin-bottom: 0.5rem;
        }
        .ant-table-row-expand-icon {
            color: #2930ff;
            border-color: #2930ff;
        }
    }
`

export const EditPairWrapper = styled.div`
    .innerContent{
        padding: 2rem;
    }
    .title {
    color: #000000;
    font-size: 24px;
    font-weight: bold;
    }
    .sub-title {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0px;
    }    
    .pairContent{
        margin: 2rem 0rem;
        .ant-input {
            width: 400px;
            height: 40px;
        }
        .ant-input-number{
            width: 400px;
            height: 40px;
        }
    }
    .btn-wrapper {
        display: flex;
        margin-top: 2.5rem;
        .ant-btn {
            flex: 1;
            height: 45px;
        }
    }
`